/**
 * 对象相关
 * @type {{objClone(*): *}}
 */
let objHelper = {
    /**
     * 对象克隆
     *
     * @param obj
     * @returns {{}}
     */
    objClone(obj) {
        var newObj = {};
        if (obj instanceof Array) {
            newObj = [];
        }
        for (var key in obj) {
            var val = obj[key];
            newObj[key] = typeof val === 'object' ? this.objClone(val): val;
        }
        return newObj;
    }
}

let amountConversion = {
    // 分转元
    penny2yuan(penny) {
        //排除非数字  
        if(penny==null || isNaN(penny) || penny === ""){
          return '0.00';  
        }  
        //排除小于1的数  
        if(parseInt(penny) < 1){  
          return '0.00';  
        }  
        //排除带小数点的数  
        var penny_str = penny + '';  
        if(penny_str.indexOf('.') > -1){  
          return '0.00';  
        }  
        var penny_len = penny_str.length;  
        if(penny_len == 1){  
          return '0.0' + penny_str;  
        }else if(penny_len == 2){  
          return '0.' + penny_str;  
        }else{  
          return penny_str.substring(0, penny_len - 2) + '.' + penny_str.substring(penny_len - 2);  
        } 
    },
    
    // 元转分
    yuantoFenney(val){  

        return parseInt(100 * (val * 1000) / 1000);  
    } 
}

let DataConversion = {
    // 根据key从Map中获取value值,key不存在返回空字符串
    getMapValueByKey(key, map){
        if (map instanceof Map && map.has(key)) {
            return map.get(key)
        }

        return "";
    }
}

export {
    objHelper,
    amountConversion,
    DataConversion
}


// WEBPACK FOOTER //
// ./src/utils/util.js